var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF5F00",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M2.9 6.32c0 .54.27.99.72 1.35l5.4 3.69c1.26.81 2.79.81 4.05 0l5.4-3.6c.36-.45.63-.9.63-1.44v0c0-.9-.72-1.62-1.62-1.62H4.52c-.9 0-1.62.72-1.62 1.62",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF5F00",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M2.9 6.5v9c0 .99.81 1.8 1.8 1.8h12.6c.99 0 1.8-.81 1.8-1.8v-9M3.43 16.77l5.484-5.484M13.124 11.324l5.447 5.447"
})));
export default SvgEmail;